import { render, staticRenderFns } from "./SystemNotice.vue?vue&type=template&id=04fff68c&scoped=true&"
import script from "./SystemNotice.vue?vue&type=script&lang=js&"
export * from "./SystemNotice.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotice.vue?vue&type=style&index=0&id=04fff68c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fff68c",
  null
  
)

export default component.exports